import React from 'react';
import { Box, Button, Typography, Container } from '@mui/material';

const Login = ({ onLogin }) => {
  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 3
        }}
      >
        <Typography variant="h4" component="h1">
          Welcome to Invoice Portal
        </Typography>
        <Typography variant="body1" textAlign="center">
          Please log in to access the portal
        </Typography>
        <Button
          variant="contained"
          size="large"
          onClick={onLogin}
        >
          Log In
        </Button>
      </Box>
    </Container>
  );
};

export default Login; 